import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { Container as Facility } from './Facility.container';
import { FacilityDetailV2 } from './v2';

export const FacilityVersion: FC<any> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2.spa-days');
  if (isV2) return <FacilityDetailV2 {...props} />;
  return <Facility {...props} />;
};
